<table class="seats-compare-table" *ngIf="rows?.length">
  <thead>
    <tr>
      <th class="party-col" colspan="2">Party</th>
      <th class="num">{{ currentYear }}</th>
      <th class="num">{{ previousYear }}</th>
      <th class="num">change</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let row of rows">
      <td class="colour-cell">
        <span class="colour-swatch" [style.backgroundColor]="row.colourCode"></span>
      </td>
      <td class="party-name">{{ row.party }}</td>
      <td class="num">{{ row.current }}</td>
      <td class="num">{{ previousLabel(row) }}</td>
      <td
        class="num change"
        [ngClass]="{ positive: row.change > 0, negative: row.change < 0 }"
      >
        {{ changeLabel(row.change) }}
      </td>
    </tr>
  </tbody>
</table>
